import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { JobAnchorEffects } from './job-anchor.effects';

@NgModule({
  imports: [EffectsModule.forFeature([JobAnchorEffects])],
})
export class JobAnchorStoreModule {}
